module.exports = __webpack_public_path__ + "img/notjoin.1f7898bc.png";